import { apolloClient } from '../../../App';

import { GET_STOCK_TRANSFERS_QUERY } from 'data/queries/stockTransfer';

import { GetStockTransfersQuery, StockTransfersUpdatedSubscription } from 'data/__generated__';

export const stockTransfersUpdatedHandler = (
    stockTransferUpdated: StockTransfersUpdatedSubscription['stockTransferUpdated'],
) => {
    if (!stockTransferUpdated) {
        return;
    }
    let currentStockTransfers = [] as GetStockTransfersQuery['stockTransfers']['stockTransfers'];
    let currentHasMore = false;
    // We can read query only if it has been run
    try {
        const result = apolloClient.readQuery<GetStockTransfersQuery>({
            query: GET_STOCK_TRANSFERS_QUERY,
        });
        if (!result) {
            throw Error('An error occurred when reading GET_STOCK_TRANSFERS_QUERY');
        }
        currentStockTransfers = result.stockTransfers.stockTransfers;
        currentHasMore = result.stockTransfers.hasMore;
    } catch {
        // do nothing
    }

    const stockTransferIds = currentStockTransfers.map(({ _id }) => _id);

    if (stockTransferIds.includes(stockTransferUpdated._id)) {
        // If this is a stockTransfer existing in the cache
        const data = {
            stockTransfers: {
                hasMore: currentHasMore,
                stockTransfers: currentStockTransfers.map((stockTransfer) => {
                    if (stockTransfer._id === stockTransferUpdated._id) {
                        return stockTransferUpdated;
                    }
                    return stockTransfer;
                }),
            },
        };
        apolloClient.writeQuery({
            query: GET_STOCK_TRANSFERS_QUERY,
            data,
        });
    } else {
        // If this is a new stockTransfer, not present in the cache
        const data = {
            stockTransfers: {
                hasMore: currentHasMore,
                stockTransfers: [...currentStockTransfers, stockTransferUpdated],
            },
        };
        apolloClient.writeQuery({
            query: GET_STOCK_TRANSFERS_QUERY,
            data,
        });
    }
};
